export enum LayerItemType {
	Orthophoto = "Ortho",
	Meshes = "Mesh",
	PointClouds = "Cloud",
	Cad = "CAD",
	Annotations = "Annotation",
	Profiles = "Profile",
	Volumes = "Volume",
}
